import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { LeadForm } from '../LeadForm/LeadForm';
import { GTM_ACTION, GTM_CLASS } from '../../lib/constant';

import styles from './StickyWhatsapp.module.scss';


const StickyWhatsapp = (props) => {
  const [stickyWA, setStickyWA] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setStickyWA(true);
    } else {
      setStickyWA(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div>
      {showPopup &&
        <div className={styles.stickyWhatsapp__popup}>
          <LeadForm
            category="whatsapp"
            gtmAction={GTM_ACTION.WHATSAPP_POPUP}
            closeWAPopup={() => setShowPopup(false)}
          />
        </div>
      }
      <a
        className={classnames(styles.stickyWhatsapp,
          GTM_CLASS.WHATSAPP_BUTTON_CLICK,
          { [`${styles['stickyWhatsapp-show']}`]: stickyWA }
        )}
        title="Chat Bantuan"
        onClick={() => setShowPopup(true)}
      >
        <div className={`iconSprites iconSprites-white-whatsapp`} />
        <span>Dapatkan Promo</span>
      </a>
    </div>
  );
};

export default StickyWhatsapp;